/**
 * Client runtime config. Reads Vite env vars (inlined at build time).
 * The API base includes the `/v1` version prefix the backend serves.
 */
export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  'http://localhost:3000/v1';

/**
 * Per-request timeout for the best-effort `POST /auth/logout` (MYN-146). Without
 * one, a hung logout could resolve as a 401 after the user has logged in again,
 * and the `apiClient` 401 interceptor would then clear the NEW session token.
 */
export const LOGOUT_REQUEST_TIMEOUT_MS = 5_000;
